// extracted by mini-css-extract-plugin
export default {"optionWrapper":"option_optionWrapper__JEkgG","active":"option_active__HzsqO"};